import PropTypes from 'prop-types';

export const dropDownItemType = PropTypes.shape({
    icon: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf([
        'button',
        'external-link',
        'internal-link',
        'link',
        'separator',
    ]).isRequired,
});
